import ChartOfAccountsStore from "./ChartOfAccounts.Store";
import { RootStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const chartOfAccountsRoute: RouteType = {
  name: "Chart Of Accounts",
  path: "/accounting/chart-of-accounts",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Chart of Accounts",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./ChartOfAccounts.Header"),
    },
    body: {
      component: () => import("./ChartOfAccounts.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const coaStore = rootStore.chartOfAccountsViewStore as ChartOfAccountsStore;
    if (coaStore) {
      await coaStore.loadAccounts();
      coaStore.expandAll();
    }
    return true;
  },
  dialogs: [
    {
      name: "addAccount",
      title: "Add Account",
      component: () => import("./dialogs/AddAccountDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const coaStore =
          rootStore.chartOfAccountsViewStore as ChartOfAccountsStore;
        await coaStore.saveAccount();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const coaStore =
          rootStore.chartOfAccountsViewStore as ChartOfAccountsStore;
        const formData = coaStore.formData;
        return !!(formData.accountNumber && formData.accountName && formData.accountType);
      },
      cancelButton: true,
      height: 600,
    },
    {
      name: "editAccount",
      title: "Edit Account",
      component: () => import("./dialogs/EditAccountDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const coaStore =
          rootStore.chartOfAccountsViewStore as ChartOfAccountsStore;
        await coaStore.saveAccount();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const coaStore =
          rootStore.chartOfAccountsViewStore as ChartOfAccountsStore;
        const formData = coaStore.formData;
        return !!(formData.accountNumber && formData.accountName && formData.accountType) && coaStore.hasFormChanges;
      },
      cancelButton: true,
      height: 600,
    },
    {
      name: "accountDetails",
      title: "Account Details",
      component: () => import("./dialogs/AccountDetailsDialog.Body"),
      cancelButton: true,
      height: 500,
    },
    {
      name: "mergeAccount",
      title: "Merge Account",
      component: () => import("./dialogs/MergeAccountDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const coaStore = rootStore.chartOfAccountsViewStore as ChartOfAccountsStore;
        await coaStore.mergeAccounts();
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const coaStore = rootStore.chartOfAccountsViewStore as ChartOfAccountsStore;
        return !!(coaStore.selectedAccountId && coaStore.mergeTargetAccountId);
      },
      submitButtonText: "Merge Accounts",
      submitButtonColor: "warning",
      cancelButton: true,
      height: 540,
    },
    {
      name: "deleteAccount",
      title: "Delete Account",
      component: () => import("./dialogs/DeleteAccountDialog.Body"),
      onClose: ({ rootStore }: { rootStore: RootStore }) => {
        (rootStore.chartOfAccountsViewStore as ChartOfAccountsStore).resetDeleteConfirmStep();
      },
      cancelButton: true,
      height: 440,
    },
  ],
};

export default chartOfAccountsRoute;
